module.exports = __webpack_public_path__ + "static/Zbiornik_magazynowy_pary_kondensatu-9c66fe6876938c3f04ea88aa3f465c31.png";